var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 16.0303V11.0303M13.3332 13.5303H18.3332M9.99984 11.0303H6.6665C5.11337 11.0303 4.3368 11.0303 3.72423 11.284C2.90747 11.6223 2.25855 12.2712 1.92024 13.088C1.6665 13.7006 1.6665 14.4771 1.6665 16.0303M12.9165 1.27257C14.1381 1.76706 14.9998 2.9647 14.9998 4.36361C14.9998 5.76251 14.1381 6.96015 12.9165 7.45464M11.2498 4.36361C11.2498 6.20456 9.75745 7.69694 7.9165 7.69694C6.07555 7.69694 4.58317 6.20456 4.58317 4.36361C4.58317 2.52266 6.07555 1.03027 7.9165 1.03027C9.75745 1.03027 11.2498 2.52266 11.2498 4.36361Z",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.ec78e5263f217e6a90fa16ab00a1242f.svg";
export { ForwardRef as ReactComponent };